const config = {
    PORT: process.env.REACT_APP_BACKEND_PORT || 3000,
    BACKEND: process.env.REACT_APP_BACKEND || "localhost",
    GRUPOS:{
    0: "Otros",
    1: "Pizarrales",
    2: "Amis",
    3: "Tierra charra",
    4: "María Auxiliadora",
    5: "Juan de la Fuente",
    6: "Trastormes",
    7: "Buenos Aires",
    8: "Tejares",
    9: "Chamberí",
    10: "San Isidro",
    11: "Puente Ladrillo",
    12: "La Vega",
    13: "San José",
    14: "Vidal",
  }
};

module.exports = config;
